import React, { useEffect } from 'react'

function LabelValueJsonEditor({jsonData,setJsonData}) {

    const _emptyJsonData = {
            label:"",
            value:"",
        }

    const addEmptyJsonData = () =>{
        
    }

    useEffect(()=>{
        if(jsonData.length === 0 ){
            let _jsonData = [];
            for(let i=0;i<5;i++){
                _jsonData.push(_emptyJsonData);
            }
            setJsonData(_jsonData)
        }
    },[])

    

    const updateJsonData = (i,field,value) =>{
        let _jsonData = [...jsonData];
        //console.log(i);
        //console.log(i, _jsonData[i])
        //console.log(i+1, _jsonData[i+1])
        const updatedObject = { ..._jsonData[i] };
        updatedObject[field] = value;
        _jsonData[i] = updatedObject;
        setJsonData(_jsonData);
    }

    /*const removeMedicine = (i) =>{
        let _medicines1 = [...medicines];
        _medicines1.splice(i,1);
        setMedicines(_medicines1);    
    }

    */

    return (
    <>
        <table className='table table-striped'>
            <thead>
                <tr>
                    <th colSpan={2} className='text-center'>Image / Attachment File Details.</th>
                </tr>
                <tr>
                    <th>Label</th>
                    <th>Value</th>
                </tr>
            </thead>
            
            <tbody>
                {jsonData.map((data,i) =>
                    <tr key={i}>
                        <td><input type='text' className='form-control' placeholder='' value={data.label}  onChange={(e)=>updateJsonData(i,"label",e.target.value)} /></td>
                        <td><input type='text' className='form-control' placeholder='' value={data.value}  onChange={(e)=>updateJsonData(i,"value",e.target.value)} /></td>
                    </tr>
                )}
            </tbody>
            
        </table>
    </>
    )
}

export default LabelValueJsonEditor